<script setup>
import Popper from 'vue3-popper';
import FormInput from '@/components/Shared/Form/Input/Index.vue';
import {kebabCase} from 'lodash';
import {computed, onBeforeMount, reactive, watch} from 'vue';

const props = defineProps({
  filters: {
    type: Array,
    required: true,
  },
  filterValues: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['filter-changed']);

const filterValues = reactive({});

onBeforeMount(() => {
  Object.keys(props.filterValues).forEach(key => {
    const filter = findFilterByKey(key);

    filterValues[key] = transformFilterValueToFormInputValue(filter, props.filterValues[key]);
  });
});

const parseName = text => kebabCase(text);

const findFilterByKey = key => {
  return props.filters.find(filter => filter.id === key);
};

const transformFilterValueToFormInputValue = (filter, value) => {
  if (value == null) {
    return null;
  }

  if (filter.type === 'select') {
    return filter.options.find(option => option[filter.trackBy] == value);
  } else if (filter.type === 'checkbox') {
    return value === 'true';
  }

  return value;
};

watch(
  () => props.filterValues,
  () => {
    if (props.filterValues) {
      Object.keys(props.filterValues).forEach(key => {
        const filter = findFilterByKey(key);

        filterValues[key] = transformFilterValueToFormInputValue(filter, props.filterValues[key]);
      });
    }
  },
  {immediate: true, deep: true},
);

watch(filterValues, () => {
  emit('filter-changed', transformedFilters.value);
});

const transformedFilters = computed(() => {
  return Object.keys(filterValues).reduce((accumulator, key) => {
    const filter = findFilterByKey(key);
    const value = filterValues[key];

    if (filter.type === 'select') {
      accumulator[key] = value?.id;
    } else {
      accumulator[key] = value;
    }

    return accumulator;
  }, {});
});
</script>

<template>
  <Popper placement="bottom" class="light" v-bind="$attrs">
    <button class="btn btn-secondary">
      <svg class="icon" style="width: 20px; height: 20px">
        <use xlink:href="#filters-icon"></use>
      </svg>
    </button>
    <template #content>
      <div class="py-2 px-3">
        <div v-for="filter in filters" :key="filter.id" class="mb-2">
          <h6>{{ filter.name }}</h6>
          <slot :name="`input-${parseName(filter.name)}`" :filter="filter">
            <form-input v-model="filterValues[filter.id]" :type="filter.type" v-bind="{ ...filter }" />
          </slot>
        </div>
      </div>
    </template>
  </Popper>
</template>
